module.exports = __webpack_public_path__ + "static/media/quote.98aefb1e.png";